<template>
    <div id="services-component">
        <b-modal v-model="showModal" hide-footer size="xl" centered scrollable :title="titleModal">
            <form id="formCrud" class="formCrud">
                <div class="row ">
                    <div class="col-12 col-md-6">
                        <select v-model="service.status" data-select="on" class="required"
                                data-name-input="Selecciona un Status">
                            <option :value="0">Selecciona un Status</option>
                            <option :value="1">Activo</option>
                            <option :value="2">Inactivo</option>
                        </select>
                    </div>
                    <div class="col-12 col-md-6">
                        <select v-model="service.tipo" data-select="on" class="required"
                                data-name-input="Selecciona un Tipo">
                            <option :value="0">Selecciona un Tipo</option>
                            <option :value="1">Básico</option>
                            <option :value="2">Extra Platino</option>
                            <option :value="3">WellMedic</option>
                            <option :value="4">Salud Digna</option>
                        </select>
                    </div>
                    <div class="col-12 col-md-12">
                        <input type="text" class="al-inputs required scr-input" placeholder="Servicio"
                               v-model="service.servicio" id="paquete"/>
                        <label for="paquete" class="scr-supertext scr-extra">Servicio</label>
                    </div>
                    <div class="col-12 col-md-12">
                        <button id="dyn-button" type="button" class="formSubmit" v-on:click="guardar()">{{ tituloBtn }}</button>
                    </div>
                </div>
            </form>
        </b-modal>
        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="barSettings">
                    <div class="row">
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                           <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3" v-model="pagination.current_page"
                                          :total-rows="pagination.total" :per-page="pagination.per_page"
                                          aria-controls="my-table" v-on:change="onChange"></b-pagination>
                        </div>
                        <div class="col-12 col-xl-6 mb-3 mb-sm-0">
                            <input id="filter-input" class="al-inputs scr-input" v-model="filter" type="search"
                                   placeholder="Buscar por palabra">
                            <label for="filter-input" class="scr-supertext scr-extra">Buscar por palabra</label>
                        </div>
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0 cont_select">
                            <select id="change_result" class="float" v-model="params.limit" v-on:change="changeLimit">
                                <option :value="10">10</option>
                                <option :value="20">20</option>
                                <option :value="30">30</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </select>
                        </div>
                        <div class="col-12 col-md-2 mb-3 mb-sm-0">
                            <button type="button" class="formSubmit" v-on:click="openModalsProviders()">{{
                                    tituloBtn
                                }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <b-table responsive id="my-table" striped hover :fields="fields" :busy="isBusy" :filter="filter"
                                 :items="pagination.data">
                            <template #head(Acciones)="{item}">
                                <i class="fa-solid fa-gear"></i>
                            </template>
                            <template #cell(Servicio)="data">
                                {{ data.item.servicio }}
                            </template>
                            <template #cell(Tipo)="data">
                                <span v-if="data.item.tipo==1" class="badge rounded-pill text-bg-success">Básico</span>
                                <span v-if="data.item.tipo==2"
                                      class="badge rounded-pill text-bg-blue">Extra Platino</span>
                                <span v-if="data.item.tipo==3"
                                      class="badge rounded-pill text-bg-orange">WellMedic</span>
                                <span v-if="data.item.tipo==4"
                                      class="badge rounded-pill text-bg-green">Salud Digna</span>
                            </template>
                            <template #cell(Status)="data">
                                <span v-if="data.item.status==2"
                                      class="badge rounded-pill text-bg-danger">Inactivo</span>
                                <span v-if="data.item.status==1"
                                      class="badge rounded-pill text-bg-success">Activo</span>
                                <span v-if="data.item.status==0"
                                      class="badge rounded-pill text-bg-danger">Sin Status</span>
                            </template>
                            <template #cell(Acciones)="{item}">
                                <div class="dropdown">
                                    <button class="btn btn-warning dropdown-toggle" type="button"
                                            id="dropdownMenuButton"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-cogs"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="modificar=true; updateReg(item)">Editar</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="onClickDelete(item.id)">Borrar</a>
                                    </div>
                                </div>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                        </b-table>
                        <div class="col-12 col-xl-2">
                           <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3" v-model="pagination.current_page"
                                          :total-rows="pagination.total" :per-page="pagination.per_page"
                                          aria-controls="my-table" v-on:change="onChange"></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {servicesService} from "../../Services/Services.service";

export default {
    name: "services",
    mixins: [myMixins],
    data() {
        return {
            modificar: false,
            isBusy: false,
            filter: null,
            fields: [
                {key: 'Servicio'},
                {key: 'Tipo'},
                {key: 'Status'},
                {key: 'Acciones'}
            ],
            params: {
                limit: 0,
                page: 1,
            },
            service: {
                id: '',
                servicio: '',
                status: 0,
                tipo: '',
            },
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            services: [],
            tituloBtn: 'Agregar',
        }
    },
    methods: {
        updateReg(data = {}) {
            if (this.modificar) {
                this.tituloBtn = 'Actualizar'
                this.service = data;
                this.openModalsProviders();
            } else {
                this.tituloBtn = 'Agregar';
                this.setEmpty();
            }
        },
        async guardar() {

            let resp = '';
            let respVal = this.valFormulariosV3();
            if (respVal) {
                this.disableSubmitBtn(true);
                if (this.modificar) {

                    resp = await servicesService.updateOne(this.service.id, this.service);

                } else {

                    resp = await servicesService.saveOne(this.service);
                }
                this.disableSubmitBtn(false);
            }
            this.setEmpty();
            this.getAlert(resp.process);

            await this.index();
            this.modificar = false;
        },
        async onClickDelete(id) {
            let resp = '';
            resp = await servicesService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        async index() {
            //console.log(this.params);
            this.isBusy = true;
            let resp = await servicesService.getMany(this.params);
            this.services = resp.data;
            this.pagination = resp;
            this.isBusy = false;
        },
        changeLimit() {
            this.index();
        },
        onChange(page) {
            this.params.page = page;
            this.index();
        },
        setEmpty() {
            this.service = {
                id: '',
                servicio: '',
                status: 0,
                tipo: '',
            }
        }

    },
    mounted() {
        this.index();
    },
}
</script>

<style scoped>
form select {
    margin: 0 !important;
}
</style>
